import React, { useState } from "react";
import "./styles.css";
import "froala-editor/js/plugins.pkgd.min.js";
import { uploadMedia } from "../../apiCall";
// import "froala-editor/js/froala_editor.pkgd.min.js";

// Require Editor CSS files.
// import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';

function stripSasTokens(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  doc.querySelectorAll("img").forEach((img) => {
    const src = img.getAttribute("src");
    if (src) {
      try {
        const url = new URL(src);
        url.search = "";
        img.setAttribute("src", url.toString());
      } catch {
        // leave invalid URLs as-is
      }
    }
  });
  return doc.body.innerHTML;
}

const FroalaEditorViewOnly = (props) => {
    const [defaultContent, setDefaultContent] = useState(props.content?.length > 0 ? stripSasTokens(props.content) : "");

    const config = {
        key: "BWC6D-16E3F3B2H3E1A6A1A9XhC-11blFe1a1PVWEc1Fd1XHTHc1THMMe1NCb1tA1A1A1D1H4A1C2B1C7D6==",
        attribution: false,
    };

    return (
        <div className="EditorComponent">
            <FroalaEditorView
                model={defaultContent}
                config={config}
            />
        </div>
    );
};

export default FroalaEditorViewOnly;
